module.exports = __webpack_public_path__ + "h5/img/live-logo.2b0aa64c.gif";